import { Box, styled } from '@mui/material';
import { ReactNode } from 'react';

import { aspectRatio } from 'utils/styles.utils';

import { LOYALTY_BEZIER } from 'constants/loyalty.constants';

interface Props {
  backgroundColor: string;
  borderColor: string;
  mixBlendMode: string;
  size: 'small' | 'medium';
  children: ReactNode;
}

const LandscapeCardContainer = ({
  backgroundColor,
  borderColor,
  mixBlendMode,
  size,
  children,
}: Props) => {
  return (
    <LandscapeCardWrapper size={size} sx={{ backgroundColor }}>
      <LandscapeCardBorder size={size} sx={{ borderColor, mixBlendMode }} />
      {children}
    </LandscapeCardWrapper>
  );
};

const LandscapeCardWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size: 'small' | 'medium' }>(({ size }) => ({
  position: 'relative',
  overflow: 'hidden',
  borderRadius: size === 'small' ? 16 : 24,
  ...aspectRatio(16, 9),
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  transition: `background-color 0.7s ${LOYALTY_BEZIER}`,
}));

const LandscapeCardBorder = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size: 'small' | 'medium' }>(({ size }) => ({
  position: 'absolute',
  top: size === 'small' ? 4 : 8,
  left: size === 'small' ? 4 : 8,
  width: size === 'small' ? 'calc(100% - 8px)' : 'calc(100% - 18px)',
  height: size === 'small' ? 'calc(100% - 8px)' : 'calc(100% - 18px)',
  border: '1px solid',
  borderRadius: size === 'small' ? 12 : 16,
  transition: `border-color 0.7s ${LOYALTY_BEZIER}`,
}));

export default LandscapeCardContainer;
